import { Fragment } from 'react';
import { H7 } from 'foundations-components/transitional/components/H7';
import { Link } from 'foundations-components/transitional/components/Link';
import { List } from 'foundations-components/transitional/components/List';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getFileFromPath = path => path.split('/').pop();
export const ImageList = ({
  images,
  subHeader,
  action,
  onTrackAction,
  fixButton: FixButton
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(H7, {
      marginInlineStart: "600",
      marginBlockEnd: "200",
      children: subHeader
    }), /*#__PURE__*/_jsx(ExpandableText, {
      maxHeight: 128,
      children: /*#__PURE__*/_jsx(List, {
        styled: true,
        marginBlockEnd: "0",
        wrapChildren: true,
        children: images.map((img, key) => {
          const {
            src,
            moduleId,
            globalResourcePath
          } = img;
          if (!src) {
            return null;
          }
          const filePath = getFileFromPath(src);
          if (moduleId) {
            return /*#__PURE__*/_jsxs(Fragment, {
              children: [/*#__PURE__*/_jsx(Link, {
                onClick: () => {
                  if (onTrackAction) {
                    onTrackAction();
                  }
                  action({
                    moduleId,
                    globalResourcePath
                  });
                },
                children: /*#__PURE__*/_jsx("span", {
                  children: filePath
                })
              }), FixButton && /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx(FixButton, {
                  moduleId: moduleId,
                  img: img
                })
              })]
            }, key);
          } else {
            return /*#__PURE__*/_jsx("span", {
              children: filePath
            }, key);
          }
        })
      })
    })]
  });
};